import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/helpers.css";
import "./styles/main.css";
import "./styles/typo.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);
